import React from 'react'
import './index.scss'
import NavBar from '../../components/navbar'

const Contact = () => (
  <>
    <NavBar />
    <div className="contact">
      <a href="mailto:gyawali_aditya@hotmail.com" style={{ color: '#ffa7c4' }}>
        gyawali_aditya@hotmail.com
      </a>
    </div>
  </>
)

export default Contact
